export var ControllerEventEnum;

!function(ControllerEventEnum) {
    ControllerEventEnum.OnPlay = "onPlay", ControllerEventEnum.OnPause = "onPause", 
    ControllerEventEnum.OnForward = "onForward", ControllerEventEnum.OnBackward = "onBackward";
}(ControllerEventEnum || (ControllerEventEnum = {}));

export var ControllerTypeEnum;

!function(ControllerTypeEnum) {
    ControllerTypeEnum.Start = "start", ControllerTypeEnum.Pause = "pause", ControllerTypeEnum.Forward = "forward", 
    ControllerTypeEnum.Backward = "backward";
}(ControllerTypeEnum || (ControllerTypeEnum = {}));
//# sourceMappingURL=constant.js.map
